export default __webpack_public_path__ + "static/media/starwars.cdc862f4.png";